import React from "react";

import aiSquaberYellowIcon from "../../../../../assets/icons/ai-squaber-yellow.svg";
import { LABEL_TYPE } from "../../../../../lib/label/labelTypes";
import Label from "../../Label";
import PremiumIcon from "../../PremiumIcon";

export const SectionHeader = ({
  shouldShowPremiumNotice,
  sectionPermissions,
  isAiGenerated = false,
  title,
  fullName,
  label
}) => {
  const isNewBadge = label?.type === LABEL_TYPE.NEW;

  return (
    <div className="squaber-stock-page-section-header">
      {isAiGenerated ? (
        <img
          src={aiSquaberYellowIcon}
          width={22}
          height={22}
          alt=""
          className="ai-generated-indicator"
        />
      ) : sectionPermissions.length > 0 ? (
        <PremiumIcon userHasAccess={!shouldShowPremiumNotice} />
      ) : null}
      {isNewBadge ? <Label type={label.type}>{label.text}</Label> : null}
      <p className="description">
        {title} <span>{` - ${fullName}`}</span>
      </p>
      {label && !isNewBadge ? (
        <Label type={label.type}>{label.text}</Label>
      ) : null}
    </div>
  );
};
